// ─────────────────────────────────────────────────────────────────────────────
// Settings feature — API давхарга. Дэлгүүр нээх/хаах төлөв.
// ─────────────────────────────────────────────────────────────────────────────
import AxiosRequest from "shared/api/httpClient";

/** Дэлгүүрийг нээх/хаах (isOpen). Backend /merchant/update. */
export async function openCloseAPI({ isOpen }) {
  return AxiosRequest({
    url: "/merchant/update",
    method: "post",
    data: { isOpen },
  });
}
